import { useEffect, useState } from 'react';

export function useWindowSize() {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  function updateSize() {
    setSize([window.innerWidth, window.innerHeight]);
  }

  useEffect(() => {
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, [setSize, updateSize]);

  return size;
}
